import { track } from './impersonation-context';

const FEATURE_NAME = 'auth';

// Module-level state - shared across all component instances
let hasTrackedLoginThisSession = false;

interface LoginEventProperties {
  login_method: 'credentials' | 'cognito_redirect';
}

interface LogoutEventProperties {
  logout_reason?: 'user_initiated' | 'session_expired' | 'forced';
}

/**
 * Track when a user successfully logs in.
 * Uses module-level deduplication to ensure only one event fires per session,
 * regardless of how many components call this function.
 */
export const trackLogin = (properties: LoginEventProperties) => {
  if (hasTrackedLoginThisSession) {
    return; // Already tracked this session
  }
  hasTrackedLoginThisSession = true;

  track('Auth: Login', {
    feature_name: FEATURE_NAME,
    ...properties,
  });
};

/**
 * Track when a user logs out.
 * Resets the login tracking flag so the next login will be tracked.
 */
export const trackLogout = (properties?: LogoutEventProperties) => {
  // Reset login tracking for next session
  hasTrackedLoginThisSession = false;

  track('Auth: Logout', {
    feature_name: FEATURE_NAME,
    ...properties,
  });
};

/**
 * Reset login tracking state.
 * Useful for testing or edge cases where logout doesn't fire.
 * @internal Exported for testing purposes
 */
export const resetLoginTracking = () => {
  hasTrackedLoginThisSession = false;
};
